/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Checkbox, Typography } from 'antd';

const LiveChatAgentFilter = ({
  id,
  currentUser,
  usersThinList,
  form,
  ...rest
}) => {
  const { t } = useTranslation();
  const [, updateState] = useState(); // Hook to force a component re-render

  return (
    <Fragment>
      <div className="border-bottom" style={{ marginLeft: -16, marginRight: -16 }}>
        <Checkbox
          className="mb-2 px-4"
          checked={!form.getFieldValue(id)?.length}
          onClick={() => {
            form.setFieldValue(id, []);
            updateState(id);
          }}
        >
          {t('All Workspace LiveChat Agents')}
        </Checkbox>
      </div>

      <Checkbox.Group
        id={id}
        className="d-flex flex-column overflow-y-auto overflow-x-hidden px-5"
        style={{ maxHeight: 140 }}
        options={[currentUser, ...(usersThinList ?? []).filter(user => user.id !== currentUser.id)].map(user => (
          {
            label: (
              <Typography.Text ellipsis>
                {user.id === currentUser.id ? 'Me' : user.fullName}
              </Typography.Text>
            ),
            value: user.id,
            style: { marginBottom: 4, marginTop: 4 }
          }
        ))}
        {...rest}
      />
    </Fragment>
  );
};

LiveChatAgentFilter.propTypes = {
  id: PropTypes.string,
  currentUser: PropTypes.object,
  usersThinList: PropTypes.array,
  form: PropTypes.object
};

export default LiveChatAgentFilter;
